import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/LocaleProvider";

/* 404.
 *
 * The previous catch-all redirected every unknown path to "/" silently, which
 * told a visitor with a mistyped or dead link that the link had worked. This
 * says the page does not exist and offers the doors that do -- search, home,
 * and pricing -- so a wrong URL ends somewhere useful rather than nowhere or,
 * worse, somewhere that pretends to be right.
 */
export function NotFound() {
  const { t } = useLocale();
  return (
    <section className="sq-404">
      <p className="sq-404__code sq-num">404</p>
      <h1 className="sq-404__title">{t.notFound.title}</h1>
      <p className="sq-404__body">{t.notFound.body}</p>
      <div className="sq-404__actions">
        <Link className="sq-404__cta" to="/">{t.notFound.home}</Link>
        <Link className="sq-404__link" to="/search">{t.notFound.search}</Link>
        <Link className="sq-404__link" to="/pricing">{t.notFound.pricing}</Link>
      </div>
    </section>
  );
}
